module.exports = __webpack_public_path__ + "static/img/1.966b7ba6.png";